/* LegBilligt — FAQ-siden
   Tre ting: soegefeltet der filtrerer med det samme, emnekortene der
   viser én gruppe ad gangen, og dybe links som /pages/faq#emne-3.

   INGEN MutationObserver. Alt er lyttere paa elementer, der findes,
   naar scriptet koerer (det er lagt ind med defer).

   Uden JS staar alle spoergsmaal fremme, og ankrene virker stadig —
   siden bliver lang, men den er hel. */
(function () {
  var spalte = document.getElementById('lbq-spalte');
  if (!spalte) return;

  var input   = document.getElementById('lbq-input');
  var ryd     = document.getElementById('lbq-ryd');
  var tal     = document.getElementById('lbq-tal');
  var tom     = document.getElementById('lbq-tom');
  var tomOrd  = document.getElementById('lbq-tom-ord');
  var tomRyd  = document.getElementById('lbq-tom-ryd');
  var svarBnd = document.getElementById('lbq-svar');

  var grupper = [].slice.call(spalte.querySelectorAll('.lbq-gr'));
  var kort    = [].slice.call(document.querySelectorAll('.lbq-e[data-g]'));
  var idxLink = [].slice.call(document.querySelectorAll('.lbq-idx-l[data-g]'));
  var chips   = [].slice.call(document.querySelectorAll('.lbq-chip[data-ord]'));

  var startTekst = tal ? tal.textContent : '';
  var valgt = 0;           /* 0 = alle emner */
  var selvAabnet = [];     /* dem soegningen selv foldede ud */

  /* ---- alle spoergsmaal samles én gang, med teksten klar til soegning ---- */
  var navne = {};
  var alle = [];
  grupper.forEach(function (gr) {
    var g = gr.getAttribute('data-g');
    var h = gr.querySelector('.lbq-gruppe');
    if (h) {
      var b = h.querySelector('b');
      navne[g] = h.textContent.replace(b ? b.textContent : '', '').trim();
    }
    [].slice.call(gr.querySelectorAll('.lbq-q')).forEach(function (q) {
      var sp = q.querySelector('summary span');
      var sv = q.querySelector('.lbq-sv');
      var spTekst = sp ? sp.textContent : '';
      alle.push({
        el: q,
        gr: gr,
        g: g,
        sp: sp,
        org: spTekst,
        tekst: (spTekst + ' ' + (sv ? sv.textContent : '')).toLowerCase()
      });
    });
  });
  if (!alle.length) return;

  /* ---- markering af det soegte ord inde i spoergsmaalet ---- */
  function saetSpoergsmaal(post, ord) {
    var sp = post.sp;
    if (!sp) return;
    if (!ord) {
      if (sp.textContent !== post.org) sp.textContent = post.org;
      return;
    }
    var i = post.org.toLowerCase().indexOf(ord);
    if (i < 0) { sp.textContent = post.org; return; }
    sp.textContent = '';
    sp.appendChild(document.createTextNode(post.org.slice(0, i)));
    var m = document.createElement('mark');
    m.className = 'lbq-tr';
    m.textContent = post.org.slice(i, i + ord.length);
    sp.appendChild(m);
    sp.appendChild(document.createTextNode(post.org.slice(i + ord.length)));
  }

  function lukSelvAabnede() {
    selvAabnet.forEach(function (q) { q.open = false; });
    selvAabnet = [];
  }

  /* ---- tegner siden efter soegeord og valgt emne ---- */
  function tegn() {
    var ord = input ? input.value.trim().toLowerCase() : '';
    var soeger = ord.length > 1;
    var traef = [];

    lukSelvAabnede();

    alle.forEach(function (post) {
      var med = true;
      if (soeger) med = post.tekst.indexOf(ord) > -1;
      else if (valgt) med = post.g === String(valgt);
      post.el.hidden = !med;
      saetSpoergsmaal(post, soeger && med ? ord : '');
      if (med) traef.push(post);
    });

    /* en gruppe uden traef skal ikke staa med en tom overskrift */
    grupper.forEach(function (gr) {
      var synlig = false;
      var qs = gr.querySelectorAll('.lbq-q');
      for (var i = 0; i < qs.length; i++) { if (!qs[i].hidden) { synlig = true; break; } }
      gr.hidden = !synlig;
      var b = gr.querySelector('.lbq-gruppe b[data-antal]');
      if (b && synlig) {
        var n = 0;
        for (var j = 0; j < qs.length; j++) { if (!qs[j].hidden) n++; }
        b.textContent = n;
      }
    });

    /* er der kun et par stykker tilbage, folder vi dem ud med det samme */
    if (soeger && traef.length && traef.length <= 3) {
      traef.forEach(function (post) {
        if (!post.el.open) { post.el.open = true; selvAabnet.push(post.el); }
      });
    }

    if (tom) {
      tom.hidden = !(soeger && traef.length === 0);
      if (!tom.hidden && tomOrd) tomOrd.textContent = '“' + input.value.trim() + '”';
    }
    if (ryd) ryd.hidden = !(input && input.value);

    if (tal) {
      if (soeger) {
        tal.textContent = traef.length === 0
          ? 'Ingen svar matcher det ord.'
          : (traef.length === 1 ? '1 svar handler om ' : traef.length + ' svar handler om ')
            + '“' + input.value.trim() + '”.';
      } else if (valgt && navne[String(valgt)]) {
        tal.textContent = traef.length + ' spørgsmål om ' + navne[String(valgt)].toLowerCase()
          + '. Klik på emnet igen for at se alle.';
      } else {
        tal.textContent = startTekst;
      }
    }

    kort.forEach(function (k) {
      k.classList.toggle('er-valgt', !soeger && valgt === parseInt(k.getAttribute('data-g'), 10));
    });
    idxLink.forEach(function (l) {
      l.classList.toggle('er-valgt', !soeger && valgt === parseInt(l.getAttribute('data-g'), 10));
    });
  }

  /* ---- hvor hoejt sidder temaets faste header? ----
     Den er ikke lige hoej paa computer og mobil, og den skrumper naar man
     har rullet. Vi maaler den i stedet for at gaette, og laegger tallet i
     --lbq-top, som baade emnelisten og rulningen regner ud fra. Ellers
     lander gruppeoverskriften inde bag headeren. */
  var lbqRod = document.querySelector('.lbq');
  var sidsteTop = 0;

  function headerBund() {
    var h = 0;
    try {
      var els = document.elementsFromPoint(Math.round(window.innerWidth / 2), 4) || [];
      for (var i = 0; i < els.length; i++) {
        var cs = window.getComputedStyle(els[i]);
        if (cs.position === 'fixed' || cs.position === 'sticky') {
          var b = els[i].getBoundingClientRect().bottom;
          /* kun noget der faktisk ligger som en bjaelke i toppen */
          if (b > h && b < window.innerHeight * 0.45) h = b;
        }
      }
    } catch (e) { /* uden elementsFromPoint bruger vi startgaettet */ }
    return h;
  }

  function opdaterTop() {
    if (!lbqRod) return 96;
    var t = Math.round(headerBund());
    if (t < 60) t = 60;
    if (t > 260) t = 260;
    if (t !== sidsteTop) {
      sidsteTop = t;
      lbqRod.style.setProperty('--lbq-top', t + 'px');
    }
    return t;
  }

  var ventTop = null;
  window.addEventListener('scroll', function () {
    if (ventTop) return;
    ventTop = setTimeout(function () { ventTop = null; opdaterTop(); }, 150);
  }, { passive: true });
  window.addEventListener('resize', opdaterTop);
  opdaterTop();

  /* ---- rulning: ned til svarene, uden at hoppe via ankeret ----
     FAELDE: temaets "scroll-behavior:smooth" goer programmeret rulning
     helt doed — scrollTo flytter ingenting. Samme problem som pilene paa
     kundeservicesiden. Derfor slaas den fra paa rodelementet, mens vi
     ruller, og saettes tilbage bagefter.

     Bagefter maaler vi én gang til: headeren skrumper tit, naar man har
     rullet, og saa skal maalet rettes, ellers staar overskriften enten
     bag headeren eller for langt nede. */
  function ryk(el, afstand) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - afstand;
    if (top < 0) top = 0;
    var rod = document.documentElement;
    var gem = rod.style.scrollBehavior;
    rod.style.scrollBehavior = 'auto';
    window.scrollTo(0, top);
    if (Math.abs(window.pageYOffset - top) > 4) {
      /* nogle temaer ruller paa body i stedet for paa html */
      document.body.style.scrollBehavior = 'auto';
      window.scrollTo(0, top);
      document.body.style.scrollBehavior = '';
    }
    rod.style.scrollBehavior = gem;
  }

  function rulTil(el) {
    if (!el) return;
    ryk(el, opdaterTop() + 20);
    /* ret efter, naar headeren har lagt sig */
    requestAnimationFrame(function () {
      var maal = opdaterTop() + 20;
      if (Math.abs(el.getBoundingClientRect().top - maal) > 6) ryk(el, maal);
    });
    setTimeout(function () {
      var maal = opdaterTop() + 20;
      if (Math.abs(el.getBoundingClientRect().top - maal) > 6) ryk(el, maal);
    }, 260);
  }

  /* Vi ruller altid til toppen af svarbaandet, ikke til selve gruppen:
     naar et emne er valgt, er det den eneste gruppe der staar, og saa
     faar man "Alle svarene" med som overskrift og kan se hvor man er. */
  function vaelg(n, rul) {
    valgt = (valgt === n) ? 0 : n;
    if (input && input.value) { input.value = ''; }
    tegn();
    if (rul) rulTil(svarBnd);
  }

  kort.concat(idxLink).forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      vaelg(parseInt(a.getAttribute('data-g'), 10), true);
    });
  });

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      if (!input) return;
      input.value = c.getAttribute('data-ord');
      valgt = 0;
      tegn();
      rulTil(svarBnd);
      input.focus();
    });
  });

  if (input) {
    var vent = null;
    input.addEventListener('input', function () {
      if (vent) clearTimeout(vent);
      vent = setTimeout(function () { valgt = 0; tegn(); }, 130);
    });
    /* Enter maa ikke sende en formular afsted og genindlaese siden */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (vent) clearTimeout(vent);
        valgt = 0; tegn(); rulTil(svarBnd);
      }
      if (e.key === 'Escape' && input.value) { input.value = ''; tegn(); }
    });
  }

  function nulstil() {
    if (input) { input.value = ''; input.focus(); }
    valgt = 0;
    tegn();
  }
  if (ryd) ryd.addEventListener('click', nulstil);
  if (tomRyd) tomRyd.addEventListener('click', function () {
    if (input) input.value = '';
    valgt = 0;
    tegn();
    rulTil(svarBnd);
  });

  /* ---- swiperaekken med emnekortene (computer OG mobil) ----
     Samme greb som pilene paa kundeservicesiden: CSS'ens
     "scroll-behavior:smooth" draeber scrollLeft, saa vi animerer selv med
     requestAnimationFrame og slaar scroll-snap fra undervejs.
     En pil fjerner sig selv, saa snart man ikke kan koere den vej — baade
     naar man klikker og naar man selv ruller/swiper. INGEN MutationObserver. */
  var raekke = document.getElementById('lbq-raekke');
  var baelte = document.getElementById('lbq-emner');
  if (raekke && baelte) {
    var pile = [].slice.call(raekke.querySelectorAll('.lbq-pil'));

    var restRul = function () { return baelte.scrollWidth - baelte.clientWidth; };

    var opdaterPile = function () {
      var m = restRul();
      pile.forEach(function (p) {
        var ret = parseInt(p.getAttribute('data-ret'), 10);
        /* Raekken har 4 px luft i kanten, og scroll-snap lander derfor tit paa
           4 og ikke 0. Uden slup ville venstrepilen staa og lyse ved start. */
        var slut = ret < 0 ? baelte.scrollLeft <= 12 : baelte.scrollLeft >= m - 12;
        p.disabled = m < 8 || slut;
      });
    };

    var rulRaekke = function (ret) {
      var kort = baelte.querySelector('.lbq-e');
      var st = window.getComputedStyle(baelte);
      var luft = parseFloat(st.columnGap || st.gap || '0') || 0;
      var skridt = kort ? kort.getBoundingClientRect().width + luft : baelte.clientWidth * 0.8;
      var maal = Math.max(0, Math.min(restRul(), baelte.scrollLeft + ret * skridt));
      var fra = baelte.scrollLeft;
      var gemSnap = baelte.style.scrollSnapType;
      baelte.style.scrollBehavior = 'auto';
      baelte.style.scrollSnapType = 'none';
      var t0 = null, tid = 340, faerdig = false;
      var slutRul = function () {
        if (faerdig) return;
        faerdig = true;
        baelte.scrollLeft = maal;
        baelte.style.scrollSnapType = gemSnap;
        opdaterPile();
      };
      var trin = function (ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / tid);
        baelte.scrollLeft = fra + (maal - fra) * (1 - Math.pow(1 - p, 3));
        if (p < 1) requestAnimationFrame(trin); else slutRul();
      };
      requestAnimationFrame(trin);
      /* vagt, hvis billedloekken ikke koerer (skjult fane, batterisparetilstand) */
      setTimeout(slutRul, tid + 140);
    };

    pile.forEach(function (p) {
      p.addEventListener('click', function () {
        rulRaekke(parseInt(p.getAttribute('data-ret'), 10));
      });
    });
    baelte.addEventListener('scroll', opdaterPile, { passive: true });
    window.addEventListener('resize', opdaterPile);
    raekke.classList.add('klar');
    opdaterPile();
  }

  /* ---- kommer man ind paa /pages/faq#emne-3, aabnes den gruppe ---- */
  function fraHash(rul) {
    var m = /^#emne-(\d+)$/.exec(window.location.hash || '');
    if (!m) return false;
    var n = parseInt(m[1], 10);
    if (!document.getElementById('emne-' + n)) return false;
    valgt = 0;
    vaelg(n, rul);
    return true;
  }
  window.addEventListener('hashchange', function () { fraHash(true); });

  if (!fraHash(false)) tegn();
})();
